export default __webpack_public_path__ + "static/media/image.bluechip-technologies-asia.826f2b47.png";